module.exports = __webpack_public_path__ + "static/fonts/Spoqa-Han-Sans-Bold.4ad74ff.woff";